const Navigation = [
    {
        title: 'Home',
        href: '/'
    },
    {
        title: 'Over ons',
        href: '/over-ons'
    },
    {
        title: 'Groepenkasten',
        href: '/diensten/groepenkast-vervangen'
    },
    {
        title: 'Zonnepanelen',
        href: '/producten/zonnepanelen'
    },
    {
        title: 'Laadpalen',
        href: '/diensten/laadpaal-installeren'
    },
    {
        title: 'Airconditioning',
        href: '/producten/airco'
    },
    {
        title: 'Storingsdienst',
        href: '/diensten/storingsdienst'
    },
    {
        title: 'Contact',
        href: '/contact'
    }
];

export default Navigation;